import { AppMode } from '../constants';

/**
 * Convert AppMode to cart_type string
 * @param {number} appMode - AppMode.SPRINT (1) or AppMode.RELAY (2)
 * @returns {string} 'sprint' or 'relay'
 */
export const getCartTypeFromAppMode = (appMode) => {
  return appMode === AppMode.RELAY ? 'relay' : 'sprint';
};

/**
 * Check if an item mode is compatible with the current cart type
 * @param {string|null|undefined} itemMode - Item mode: 'sprint', 'relay', 'both', or null/undefined
 * @param {string} cartType - Current cart type: 'sprint' or 'relay'
 * @returns {boolean} True if item can be added to cart
 */
export const isItemCompatibleWithCart = (itemMode, cartType) => {
  // Items without mode or with mode 'both' can be added to any cart
  if (!itemMode || itemMode === 'both') return true;
  // Item mode must match cart type
  return itemMode === cartType;
};

/**
 * Get current cart type from Redux state
 * @param {Function} getState - Redux getState function
 * @returns {string} 'sprint' or 'relay'
 */
export const getCurrentCartType = (getState) => {
  const state = getState();
  const appMode = (state.settings && state.settings.appMode) || AppMode.SPRINT;
  return getCartTypeFromAppMode(appMode);
};

/**
 * Get cart type from user's current_cart_type or fallback to app mode
 * @param {Function} getState - Redux getState function
 * @returns {string} 'sprint' or 'relay'
 */
export const getCartTypeFromUser = (getState) => {
  const state = getState();
  const user = state.user && state.user.user ? state.user.user : null;
  
  // If user has current_cart_type set, use it
  if (user && user.data && user.data.current_cart_type) {
    return user.data.current_cart_type;
  }
  
  // Otherwise, use app mode
  return getCurrentCartType(getState);
};
